import React from 'react';

/* packages */
import DesignSection from '../../util-mui-design-section';
/* packages */

const Index = props => {
  return <DesignSection.Title>
    Contact List
  </DesignSection.Title>
}

export default Index;
